import styled from 'styled-components';

export const DetailList = styled.div`
	line-height: 1.65;
	font-weight: 600;

	span {
		font-weight: 300;
	}
`;
